module.exports = __webpack_public_path__ + "img/certif_03.7d6c1b81.jpg";